import React, { useContext, useEffect, useState } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import SectionComponentForOwned from "./SectionComponentForOwn";
import SectionComponentForRequestedCourses from "./SectionComponentForRequestedCourses";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function CourseAllocationComponentForReqCourses({
  courseCode,
  courseDept,
  courseOwner,
}) {
  let api = useAxiosPrivate();

  let [owned, setOwned] = useState(true);
  let [sections, setsections] = useState([]);
  let [loading, setLoading] = useState(false);
  let [isMounted, setIsMounted] = useState(true);

  let getCourseGroups = async (code, signal) => {
    setLoading(true);

    let respdata = await api.get(
      `courseallocation/allocation/new?course=${code}`,
      {
        signal,
      }
    );
    isMounted && setsections(respdata.data);
    setLoading(false);
  };

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getCourseGroups(courseCode, controller.signal);
    if (courseDept != courseOwner) {
      setOwned(false);
    }

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  if (sections.length > 0) {
    return sections.map((section, key) => (
      <SectionComponentForRequestedCourses
        section={section}
        sectionID={section.id}
        courseCode={courseCode}
        courseDept={courseDept}
        courseOwner={courseOwner}
        getCourseGroups={getCourseGroups}
        owned={owned}
        key={key}
      />
    ));
  } else {
    return (
      <React.Fragment>
        {loading == false && (
          <h3 style={{ textAlign: "center" }}>No Sections Available</h3>
        )}
        {loading == true && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </React.Fragment>
    );
  }
}

export default CourseAllocationComponentForReqCourses;
